
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop } from "vue-property-decorator";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  components: {},
  filters,
})
export default class TextEditor extends Vue {
  @Prop({ default: "" })
  private data!: string;
  @Prop({ default: "" })
  private placeholder!: string;

  private editor = ClassicEditor;
  private config = {
    alignment: {
      options: ["left", "right"],
    },
    items: [
      "undo",
      "redo",
      "|",
      "heading",
      "|",
      "fontfamily",
      "fontsize",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "strikethrough",
      "subscript",
      "superscript",
      "code",
      "|",
      "link",
      "uploadImage",
      "blockQuote",
      "codeBlock",
      "|",
      "alignment",
      "|",
      "bulletedList",
      "numberedList",
      "todoList",
      "outdent",
      "indent",
    ],
    shouldNotGroupWhenFull: true,
    placeholder: this.placeholder,
  };
}
